<ndp-page-content>
  <div class="page-image-container">
    <img ngSrc="nursing-collaboration.svg" alt="" width="300" height="300" priority />
  </div>
</ndp-page-content>
